import { AppSwitcher as AppSwitcherWSC } from '@trackman/web-shared-components';
import { useGetApps } from 'hooks/startupHooks';
import { useTranslation } from 'react-i18next';

type Props = {
  setDisplayContent: React.Dispatch<React.SetStateAction<boolean>>;
};

const AppSwitcher = ({ setDisplayContent }: Props) => {
  const { data: appsRaw } = useGetApps();
  const { t } = useTranslation();

  if (!appsRaw) return null;

  const apps = appsRaw.map((app) => ({
    id: app.id,
    appLabel: app.display_name,
    groupLabel: app.group,
    iconName: app.icon_name,
    url: app.base_url,
  }));

  return (
    <AppSwitcherWSC
      label={t('AppSwitcher')}
      apps={apps}
      onAppClick={(appUrl) => {
        setDisplayContent(false);
        window.location.href = appUrl;
      }}
      activeAppId={'BBR'}
    />
  );
};

export default AppSwitcher;
